/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_P1Inputs */

const tr_onbilgi_s10_p1 = /** @type {(inputs: Onbilgi_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-i uyarınca dijital içeriğin işlevselliğini ve güvenliğini sağlamak için uygulanan teknik koruma önlemleri:`)
};

const en_onbilgi_s10_p1 = /** @type {(inputs: Onbilgi_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical protection measures applied pursuant to Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-i to ensure the functionality and security of the digital content:`)
};

const de_onbilgi_s10_p1 = /** @type {(inputs: Onbilgi_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische Schutzmaßnahmen, die nach Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-i zur Sicherstellung der Funktionalität und Sicherheit der digitalen Inhalte angewendet werden:`)
};

const ru_onbilgi_s10_p1 = /** @type {(inputs: Onbilgi_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технические меры защиты, применяемые согласно Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-i для обеспечения функциональности и безопасности цифрового содержимого:`)
};

/**
* | output |
* | --- |
* | "Technical protection measures applied pursuant to Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-i to ensure the functionality and security of the digital content:" |
*
* @param {Onbilgi_S10_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_p1 = /** @type {((inputs?: Onbilgi_S10_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_p1(inputs)
	if (locale === "de") return de_onbilgi_s10_p1(inputs)
	if (locale === "ru") return ru_onbilgi_s10_p1(inputs)
	return tr_onbilgi_s10_p1(inputs)
});